import { ConversionBarContainerProps } from './ConversionBarContainer';

type CompactCheckoutFlags =
    ConversionBarContainerProps['compactCheckoutDisqualifications'];

export type CondensedCheckoutExclusionProps = {
    isRsvp: CompactCheckoutFlags['is_rsvp'];
};

export const isCondensedCheckoutExcluded = (
    props: CondensedCheckoutExclusionProps,
): boolean => {
    const exclusionConditions = [props.isRsvp];

    return exclusionConditions.some(Boolean);
};
